import { OrderTrackingResponse } from 'order/wizard/orderTracking/interface/OrderTracking';

export enum orderTrackingActions {
  GET_ORDER_TRACKING = 'GET_ORDER_TRACKING',
}

export const getOrderTracking = (
  orderId: string,
  onSuccess: (orderTracking?: OrderTrackingResponse) => void,
  onFailed: () => void
) => ({
  type: orderTrackingActions.GET_ORDER_TRACKING,
  payload: orderId,
  onSuccess,
  onFailed,
});
